/**
 * Admin page rendered at "/admin/bounties" (nested route inside AdminHomepage, which
 * is mounted at "/admin/*" behind an admin-only ProtectedRoute). Wraps a single
 * "bounties" tab in TabbedPage that shows an AdminListViewContainer for regular
 * (non-AI) bounties; clicking a row opens BountyCreateEdit in edit mode.
 */
import TabbedPage from "@/components/TabbedPage";
import AdminListViewContainer from "@/pages/admin/AdminListViewContainer";
import React from "react";

const BountiesAdminPage: React.FC = () => {
    return (
        <TabbedPage
            tabs={[
                {
                    tabName: "bounties",
                    render: () => <AdminListViewContainer key="bounties" listItemType="bounty" />,
                },
            ]}
        />
    );
};

export default BountiesAdminPage;
